/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.1: '*'
...
*/
var TextOver = new Class({
	Implements: [Events, Options],

	options: {
		dismiss_on_click: false,
		offset: { x: 0, y: 0 }
	},

	initialize: function(_element, options){
		this.setOptions(options);
		this._element = _element;

		if(this._element && this._element.getProperty('title')){
			(function(){
				this.build();
			}.bind(this)).delay(500); //delay is for autocompleted fields
		}
	},

	build: function(){
		var type = this._element.getProperty('type');

		if(type == 'text' || type == 'password' || type == "textarea"){
			var _label = this._label = new Element( 'label', {
				'text': this._element.getProperty('title'),
				'class': 'overTxtLabel',
				'for': this._element.get('id')
			});

			var offset_x, offset_y;

			try{
				offset_x = this._element.getAttribute('data-offset-x').toInt();
			}catch(e){}

			try{
				offset_y = this._element.getAttribute('data-offset-y').toInt();
			}catch(e){}

			if(!offset_x || offset_x == NaN)
				offset_x = this.options.offset.x;

			if(!offset_y || offset_y == NaN)
				offset_y = this.options.offset.y;

			var left = this._element.getStyle('paddingLeft').toInt() + this._element.getParent().getStyle('paddingLeft').toInt() + offset_x,
					top = this._element.getStyle('paddingTop').toInt() + this._element.getParent().getStyle('paddingTop').toInt() + offset_y;

			_label.setStyles({
				'left': left,
				'top': top,
				'font-size': this._element.getStyle('fontSize').toInt()
			});

			_label.inject(this._element, 'after');
			this.toggle_label(true);

			if(this.options.dismiss_on_click == false){
				if(Core.is_ie8())
					this._element.attachEvent('onpropertychange', this.toggle_label.bind(this));
				else
					this._element.addEvent('input', this.toggle_label.bind(this));
			}else{
				this._element.addEvents({
					'focus': this.toggle_label.bind(this),
					'blur': function(){ this.toggle_label(true) }.bind(this)
				});
			}
		}

		this.fireEvent('labeled');
	},

	toggle_label: function(is_blur){
		if(this.options.dismiss_on_click == false || is_blur == true){
			if(this._element.value.trim() != ''){
				this._label.hide();
			}else{
				if(this._element.value == ' '){
					this._element.value = '';
				}
				this._label.show();
			}
		}else{
			this._label.hide();
		}
	}
});
